import tools from "../../../../../helpers/tools";

// Ce qui distingue un lead entreprise (PRO) d'un lead DOMI dans la carte
// commune : produit, nom, lien, onglets, type de devis, droits. Fonctions
// pures, testées avec Jest.

export const DOCUMENT_TYPE_PAR_PRODUIT = {
  MRP: "DEVIS_MRP_LEAD_ENTREPRISE",
  AC: "DEVIS_AC_LEAD_ENTREPRISE",
  PJ: "DEVIS_PJ_LEAD_ENTREPRISE",
  CYBER: "DEVIS_CYBER_LEAD_ENTREPRISE",
  RCPRO: "DEVIS_RCPRO_LEAD_ENTREPRISE",
  domi: "DEVIS_DOMI",
};

export const ENTITY_REF_PAR_CATEGORIE = {
  PRO: "Lead",
  DOMI: "Quote",
};

const ONGLET_INFOS = { id: "infos", libelle: "Infos et documents", court: "Infos", icone: "fa-file-alt" };
const ONGLET_COMMENTAIRES = { id: "commentaires", libelle: "Commentaires", court: "Commentaires", icone: "fa-comment-alt" };
const ONGLET_TACHES = { id: "taches", libelle: "Tâches", court: "Tâches", icone: "fa-tasks" };
const ONGLET_LIEES = { id: "liees", libelle: "Demandes liées", court: "Demandes liées", icone: "fa-link" };

// Onglets du panneau, dans l'ordre de la barre d'accès. Les demandes liées
// (autres demandes de la même société) n'existent que pour les entreprises.
export const ONGLETS_PAR_CATEGORIE = {
  PRO: [ONGLET_INFOS, ONGLET_COMMENTAIRES, ONGLET_TACHES, ONGLET_LIEES],
  DOMI: [ONGLET_INFOS, ONGLET_COMMENTAIRES, ONGLET_TACHES],
};

// Produit du lead d'après les constantes (QUOTATION_PRODUCT_TYPES pour les
// entreprises, QUOTE_PRODUCT_TYPES pour DOMI) : icône, libellé, code court.
export const produitDuLead = (lead = {}, productCategory, constants = {}) => {
  const liste = (productCategory === "DOMI" ? constants.QUOTE_PRODUCT_TYPES : constants.QUOTATION_PRODUCT_TYPES) || [];
  const ref = liste.find((p) => String(p.id) === String(lead.productId));
  const code = String(lead.productId || "").toUpperCase();
  return {
    icone: `fa-${(ref && ref.icon) || "file-alt"}`,
    libelle: ref && ref.name ? `Produit : ${ref.name}` : `Produit ${code}`,
    nom: (ref && ref.name) || code,
    code,
  };
};

export const nomDuLead = (lead = {}, productCategory) => {
  if (productCategory === "DOMI") return tools.getFullName(lead.user);
  return (lead.client && lead.client.company) || "Société inconnue";
};

// Lien du nom : la société (par SIRET) ou le particulier (par email) dans la
// liste des clients, dans un nouvel onglet.
export const lienDuLead = (lead = {}, productCategory) => {
  if (productCategory === "DOMI") {
    const email = lead.user && lead.user.email;
    return email
      ? { to: `/client-list?email=${encodeURIComponent(email)}`, titre: "Rechercher ce client dans un nouvel onglet" }
      : null;
  }
  const siret = (lead.establishment && lead.establishment.siret) || (lead.client && lead.client.siret);
  return siret
    ? { to: `/client-list?sirenOuSiret=${encodeURIComponent(siret)}`, titre: "Ouvrir la société dans un nouvel onglet" }
    : null;
};

export const peutDeposerDevis = (myRole) => Boolean(myRole && myRole !== "PARTNER");

// Les leads DOMI ne s'assignent qu'à l'équipe Perceval, pas aux partenaires
// (règle de l'ancien sélecteur).
export const filtreCandidatsAssignation = (productCategory) =>
  productCategory === "DOMI" ? (manager) => !(manager.roles || []).some((r) => r.roleKey === "PARTNER") : () => true;

// Tarif du devis DOMI : le dernier prix calculé, s'il existe.
export const tarifDuDevis = (lead = {}) => {
  const prix = Array.isArray(lead.prices) && lead.prices.length ? lead.prices[lead.prices.length - 1].price : null;
  return prix || null;
};
